import React, { Component } from 'react';
import {TYPE_FAIL, INTERVAL} from 'assets/constants/Constants';
import {CAMERA_ICON} from 'assets/constants/Icons';
import ShowToast from 'components/ShowToast';
import { defaultFormatDateTime,validateIsoDateFormat,validateBitStatusAlarms, totalizerUnit, flowUnit,setFlowUnit151,setTotalizerUnit151, getAlarmTypeFor151BO,setTotalizerUnit153,setFlowUnit153,getAlarmType153RWM, setPressureUnit171,getAlarmType171BPT, setRadarUnit138 } from "lib/utils"
import MaterialTable from "material-table";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import TableChartIcon from "@mui/icons-material/TableChart";

export class ReadingListTable extends Component {
    constructor (props) {
        super (props)

        this.state = {
            viewReadingImage: false,
            readingImageSource: "",
            meterApplicationType: this.props.meterApplicationType,
        }
    }

    viewImage = (readingImage) => {
        if (readingImage !== "" && readingImage !== undefined) {
            this.setState({
                viewReadingImage: true,
                readingImageSource: readingImage
            });
        }
        else {
            ShowToast("Image not uploaded yet.", TYPE_FAIL, INTERVAL, null, "");
        }
    }

    render() {
        console.log("!this.props.pageName::",this.props.pageName)
        return (
            <div>
                {
                    this.props.pageName === "AMI Readings" && (
                        <div className="ami-readings-table-container">
                            <MaterialTable
                                columns={
                                    [
                                        { title: "Serial Number", field: "serialNumber", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Web Receive Time", field: "webReceiveTime", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        //{ title: "Route", field: "route", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: this.props.pageName === "AMI Readings" ? "Gateway" : "Aqualink", field: "gateway", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        //{ title: "Reader", field: "reader", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Unit", field: "unit", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Receiver Type", field: "receiverType", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Meter Status", field: "meterStatus", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Alarm Type", field: "alarmType", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Meter Time", field: "meterTime", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Readings", field: "readings", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Photo", field: "photo", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 }, },
                                        { title: "RSSI", field: "rssi", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "SSR", field: "ssr", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                    ]
                                }
                                data={[
                                    ...this.props.readingRadarList.map((readingItem) => {
                                        let meterStatusClass = "unread";
                                        if (readingItem.meter_status === "Manual") {
                                            meterStatusClass = "manual";
                                        }
                                        else if (readingItem.meter_status === "Auto+Alarm") {
                                            meterStatusClass = "alarm";
                                        }
                                        else if (readingItem.meter_status === "Auto Read") {
                                            meterStatusClass = "read";
                                        }
                                        return {
                                            serialNumber: readingItem.meter_serial_no,
                                            webReceiveTime: defaultFormatDateTime(readingItem.created_date_time),
                                            route: !this.props.pageName && (readingItem.route_name),
                                            gateway: readingItem.network_info,
                                            reader: !this.props.pageName && (readingItem.assigned_user_id),
                                            unit: readingItem.level_distance_unit !== null ? (readingItem.level_distance_unit === "0" ? "meter" : readingItem.level_distance_unit === "1" ? "cm" : readingItem.level_distance_unit === "2" ? "mm" : "NA") : "NA",
                                            meterStatus: <span className={` ${meterStatusClass}`}>{readingItem.meter_status}</span>,
                                            alarmType: validateBitStatusAlarms(readingItem.alarm_type),
                                            meterTime: validateIsoDateFormat(readingItem.network_time_stamp) ? defaultFormatDateTime(readingItem.network_time_stamp) : readingItem.network_time_stamp,
                                            readings: readingItem.level_distance_reading ? readingItem.level_distance_reading : "NA",
                                            photo: <i className={(readingItem.reading_image !== "" && readingItem.reading_image !== undefined) ? `${CAMERA_ICON} camera-icon` : `${CAMERA_ICON} gray-icon`} title="Reading Image" onClick={() => this.viewImage(readingItem.reading_image)} />,
                                            rssi: "NA",
                                            ssr: "NA",
                                        }
                                    }),
                                    ...this.props.readingList.map((readingItem) => {
                                        let meterStatusClass = "unread";
                                        if (readingItem.meter_status === "Manual") {
                                            meterStatusClass = "manual";
                                        }
                                        else if (readingItem.meter_status === "Auto+Alarm") {
                                            meterStatusClass = "alarm";
                                        }
                                        else if (readingItem.meter_status === "Auto Read") {
                                            meterStatusClass = "read";
                                        }
                                        return {
                                            serialNumber: readingItem.meter_serial_no,
                                            webReceiveTime: defaultFormatDateTime(readingItem.created_date_time),
                                            route: !this.props.pageName && (readingItem.route_name),
                                            gateway: readingItem.gway_device_id ? readingItem.gway_device_id : "NA",
                                            reader: !this.props.pageName && (readingItem.assigned_user_id),
                                            unit: readingItem.unit !== null ? (readingItem.unit === "0" || readingItem.unit === "m³" || readingItem.unit === "m3"  ? "m³" : readingItem.unit === "1" || readingItem.unit === "L" ? "L" : readingItem.unit === "2" || readingItem.unit === "GAL" ? "GAL" : readingItem.unit === "3" || readingItem.unit === "ft3" ? "ft3" : "NA") : "NA",
                                            receiverType: readingItem.original_receiver ? readingItem.original_receiver : "NA",
                                            meterStatus: <span className={` ${meterStatusClass}`}>{readingItem.meter_status}</span>,
                                            alarmType: validateBitStatusAlarms(readingItem.alarm_type),
                                            meterTime: validateIsoDateFormat(readingItem.receive_date_time) ? defaultFormatDateTime(readingItem.receive_date_time) : readingItem.receive_date_time,
                                            readings: readingItem.meter_reading ? readingItem.meter_reading : "NA",
                                            photo: <i className={(readingItem.reading_image !== "" && readingItem.reading_image !== undefined) ? `${CAMERA_ICON} camera-icon` : `${CAMERA_ICON} gray-icon`} title="Reading Image" onClick={() => this.viewImage(readingItem.reading_image)} />,
                                            rssi: readingItem.field_strength_rssi !== undefined ? readingItem.field_strength_rssi : "NA",
                                            ssr: readingItem.snr !== undefined ? readingItem.snr : "NA",
                                        }
                                    })
                                ]}
                                options={{
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white',
                                    }),
                                    sorting: true,
                                    headerStyle: {
                                        color: "black",
                                        fontSize: 15,
                                        fontWeight: 'bolder'
                                    },
                                    pageSize: this.props.pageSize,
                                    pageSizeOptions: [10, 50, 100, 500],
                                    onChangeRowsPerPage: this.props.onChangePage ? (pageSize) => this.props.onChangePage(0, pageSize) : (pageSize) => this.setState({ pageSize }),
                                    columnsButton: false,
                                }}
                                actions={this.props.amiExportHandlers ? [
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#d32f2f", fontWeight: 500, fontSize: 15 }}>
                                                <PictureAsPdfIcon style={{ marginRight: 4 }} />
                                                PDF
                                            </div>
                                        ),
                                        tooltip: "Export PDF",
                                        isFreeAction: true,
                                        onClick: () => this.props.amiExportHandlers.onPdf(),
                                    },
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#2e7d32", fontWeight: 500, fontSize: 15 }}>
                                                <DescriptionIcon style={{ marginRight: 4 }} />
                                                Excel
                                            </div>
                                        ),
                                        tooltip: "Export Excel",
                                        isFreeAction: true,
                                        onClick: () => this.props.amiExportHandlers.onExcel(),
                                    },
                                    {
                                        icon: () => (
                                            <div style={{ display: "flex", alignItems: "center", color: "#1565c0", fontWeight: 500, fontSize: 15 }}>
                                                <TableChartIcon style={{ marginRight: 4 }} />
                                                CSV
                                            </div>
                                        ),
                                        tooltip: "Export CSV",
                                        isFreeAction: true,
                                        onClick: () => this.props.amiExportHandlers.onCsv(),
                                    },
                                ] : undefined}
                    page={this.props.currentPage}
                    totalCount={this.props.totalCount}
                    onChangePage={this.props.onChangePage}
                            />
                        </div>
                    )
                }
                {
                    this.props.pageName === "Flow Readings" && (
                        console.log("meterApplicationType::",this.state.meterApplicationType),
                        <div>
                            <MaterialTable                                columns={
                                    [
                                        // { title: "SN", field: "sn", cellStyle: { cellWidth: '14% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Serial Number", field: "serialNumber", cellStyle: { cellWidth: '0% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Meter Date and Time", field: "dateandtime", cellStyle: { cellWidth: '10% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Totalizer", field: "totalizer", cellStyle: { cellWidth: '10% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Flowrate", field: "flowrate", cellStyle: { cellWidth: '10% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Status", field: "status", cellStyle: { cellWidth: '10% !important', color: '#000000', fontSize: 13 } },
                                        { title: "Network Timestamp", field: "timestamp", cellStyle: { cellWidth: '10% !important', color: '#000000', fontSize: 13 } },
                                    ]
                                }
                                data={[
                                    ...this.props.readingList.map((readingItem, index) => {
                                        let meterStatusClass = "unread";
                                        if (readingItem.meter_status === "Manual") {
                                            meterStatusClass = "manual";
                                        }
                                        else if (readingItem.meter_status === "Auto+Alarm") {
                                            meterStatusClass = "alarm";
                                        }
                                        else if (readingItem.meter_status === "Auto Read") {
                                            meterStatusClass = "read";
                                        }
                                        return {
                                            //sn: (index + 1),
                                            serialNumber: readingItem.meter_serial_no,
                                            dateandtime: validateIsoDateFormat(readingItem.start_time_stamp) ? defaultFormatDateTime(readingItem.start_time_stamp) : readingItem.start_time_stamp,
                                            totalizer : this.state.meterApplicationType === "Forward Totalizer" 
                                                ? ( readingItem.forward_totalizer !== undefined ? (readingItem.device_type === "151BO"  ? setTotalizerUnit151(readingItem.forward_totalizer, readingItem.totalizer_unit) : setTotalizerUnit153(readingItem.forward_totalizer, readingItem.totalizer_unit)) : "NA") 
                                                : this.state.meterApplicationType === "Reverse Totalizer"
                                                ? ( readingItem.reverse_totalizer !== undefined ? (readingItem.device_type === "151BO"  ? setTotalizerUnit151(readingItem.reverse_totalizer, readingItem.totalizer_unit) : setTotalizerUnit153(readingItem.reverse_totalizer, readingItem.totalizer_unit)) : "NA") 
                                                : this.state.meterApplicationType === "Difference Totalizer" 
                                                ? ( readingItem.totalizer_difference !== undefined ? (readingItem.device_type === "151BO" ? setTotalizerUnit151(readingItem.totalizer_difference, readingItem.totalizer_unit) : setTotalizerUnit153(readingItem.totalizer_difference, readingItem.totalizer_unit)) : "NA") 
                                                : "NA",
                                            flowrate: readingItem ? (readingItem.device_type === "151BO" ? (readingItem.flow_rate !== undefined ? setFlowUnit151(readingItem.flow_rate, readingItem.flow_unit) : "NA") : (readingItem.flow_rate !== undefined ? setFlowUnit153(readingItem.flow_rate, readingItem.flow_unit) : "NA")): "NA",
                                            status: readingItem.alarm_type ? readingItem.device_type === "151BO"  ? getAlarmTypeFor151BO(readingItem.alarm_type) : readingItem.device_type === "153RWM" ? getAlarmType153RWM(readingItem.alarm_type) : "NA":"NA",
                                            timestamp: validateIsoDateFormat(readingItem.network_time_stamp) ? defaultFormatDateTime(readingItem.network_time_stamp) : readingItem.network_time_stamp,
                                        } 
                                    })
                                ]}
                                options={{
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white',
                                    }),
                                    sorting: true,
                                    headerStyle: {
                                        color: "black",
                                        fontSize: 15,
                                        fontWeight: 'bolder'
                                    },
                                    pageSize: 10,
                                    pageSizeOptions: [10, 20, 50, 100],
                                    columnsButton: true,
                                }}
                            />
                        </div>
                    )}
                     {this.props.pageName === "Pressure Readings" && (
                        <div>
                          <MaterialTable
                            columns={[
                              {
                                title: "SN",
                                field: "sn",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Serial Number",
                                field: "serialNumber",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Meter Date and Time",
                                field: "dateandtime",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Pressure",
                                field: "pressure",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Network Date and Time",
                                field: "timestamp",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Status",
                                field: "status",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                            ]}
                            data={[
                              ...this.props.readingList.map((readingItem, index) => {
                                console.log("readingItem-pressure",readingItem)
                                let meterStatusClass = "unread";
                                if (readingItem.meter_status === "Manual") {
                                  meterStatusClass = "manual";
                                } else if (readingItem.meter_status === "Auto+Alarm") {
                                  meterStatusClass = "alarm";
                                } else if (readingItem.meter_status === "Auto Read") {
                                  meterStatusClass = "read";
                                }
                                return {
                                  sn: index + 1,
                                  serialNumber: readingItem.meter_serial_no,
                                  dateandtime: validateIsoDateFormat(readingItem.start_time_stamp )? defaultFormatDateTime(readingItem.start_time_stamp) : readingItem.start_time_stamp,
                                  pressure: readingItem ? setPressureUnit171(readingItem.pressure_value, readingItem.pressure_unit): "NA",
                                  timestamp: validateIsoDateFormat(readingItem.network_time_stamp )? defaultFormatDateTime(readingItem.network_time_stamp) : readingItem.network_time_stamp,
                                  status: readingItem ?  getAlarmType171BPT(readingItem.alarm_type) :"NA",
                                };
                              }),
                            ]}
                            options={{
                              rowStyle: (rowData, index) => ({
                                backgroundColor: index % 2 === 0 ? "#f2f2f2" : "white",
                              }),
                              sorting: true,
                              headerStyle: {
                                color: "black",
                                fontSize: 15,
                                fontWeight: "bolder",
                              },
                              pageSize: 10,
                              pageSizeOptions: [10, 20, 50, 100],
                              columnsButton: true,
                            }}
                          />
                        </div>
                      )}

                 {this.props.pageName === "Level Readings" && (
                        <div>
                          <MaterialTable
                            columns={[
                              {
                                title: "SN",
                                field: "sn",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Serial Number",
                                field: "serialNumber",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Meter Date and Time",
                                field: "dateandtime",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Level",
                                field: "level",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Network Date and Time",
                                field: "timestamp",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                              {
                                title: "Status",
                                field: "status",
                                cellStyle: {
                                  cellWidth: "10% !important",
                                  color: "#000000",
                                  fontSize: 13,
                                },
                              },
                            ]}
                            data={[
                              ...this.props.readingList.map((readingItem, index) => {
                                console.log("readingItem-level",readingItem)
                                let meterStatusClass = "unread";
                                if (readingItem.meter_status === "Manual") {
                                  meterStatusClass = "manual";
                                } else if (readingItem.meter_status === "Auto+Alarm") {
                                  meterStatusClass = "alarm";
                                } else if (readingItem.meter_status === "Auto Read") {
                                  meterStatusClass = "read";
                                }
                                return {
                                  sn: index + 1,
                                  serialNumber: readingItem.meter_serial_no,
                                  dateandtime: validateIsoDateFormat(readingItem.start_time_stamp )? defaultFormatDateTime(readingItem.start_time_stamp) : readingItem.start_time_stamp,
                                  level:  setRadarUnit138(readingItem.level_distance_reading, readingItem.level_distance_unit),
                                  timestamp: validateIsoDateFormat(readingItem.network_time_stamp )? defaultFormatDateTime(readingItem.network_time_stamp) : readingItem.network_time_stamp,
                                  status: "High",
                                };
                              }),
                            ]}
                            options={{
                              rowStyle: (rowData, index) => ({
                                backgroundColor: index % 2 === 0 ? "#f2f2f2" : "white",
                              }),
                              sorting: true,
                              headerStyle: {
                                color: "black",
                                fontSize: 15,
                                fontWeight: "bolder",
                              },
                              pageSize: 10,
                              pageSizeOptions: [10, 20, 50, 100],
                              columnsButton: true,
                            }}
                          />
                        </div>
                      )}

            {this.props.pageName === "Over Head Tank Readings" && (
              <div>
                <MaterialTable
                  columns={[
                    {
                      title: "Serial Number",
                      field: "serialNumber",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Meter Date and Time",
                      field: "dateandtime",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Totalizer",
                      field: "totalizer",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Flowrate",
                      field: "flowrate",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Pressure",
                      field: "pressure",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Level",
                      field: "level",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Network Date and Time",
                      field: "timestamp",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                    {
                      title: "Status",
                      field: "status",
                      cellStyle: {
                        cellWidth: "10% !important",
                        color: "#000000",
                        fontSize: 13,
                      },
                    },
                  ]}
                  data={[
                    ...this.props.readingList.map((readingItem, index) => {
                      console.log("readingItem-level", readingItem)
                      let meterStatusClass = "unread";
                      if (readingItem.meter_status === "Manual") {
                        meterStatusClass = "manual";
                      } else if (readingItem.meter_status === "Auto+Alarm") {
                        meterStatusClass = "alarm";
                      } else if (readingItem.meter_status === "Auto Read") {
                        meterStatusClass = "read";
                      }
                      return {
                        serialNumber: readingItem.meter_serial_no,
                        dateandtime: validateIsoDateFormat(readingItem.start_time_stamp) ? defaultFormatDateTime(readingItem.start_time_stamp) : readingItem.start_time_stamp,
                        totalizer : readingItem ? setTotalizerUnit151(readingItem.forward_totalizer, readingItem.totalizer_unit): "NA",
                        flowrate: readingItem ? setFlowUnit151(readingItem.flow_rate, readingItem.flow_unit) : "NA",
                        pressure: readingItem ? setPressureUnit171(readingItem.pressure_value, readingItem.pressure_unit): "NA",
                        level: readingItem ? setRadarUnit138(readingItem.level_distance_reading, readingItem.level_distance_unit): "NA",
                        timestamp: validateIsoDateFormat(readingItem.network_time_stamp) ? defaultFormatDateTime(readingItem.network_time_stamp) : readingItem.network_time_stamp,
                        status: readingItem ? getAlarmTypeFor151BO(readingItem.alarm_type) : "NA",
                      };
                    }),
                  ]}
                  options={{
                    rowStyle: (rowData, index) => ({
                      backgroundColor: index % 2 === 0 ? "#f2f2f2" : "white",
                    }),
                    sorting: true,
                    headerStyle: {
                      color: "black",
                      fontSize: 15,
                      fontWeight: "bolder",
                    },
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    columnsButton: true,
                  }}
                />
              </div>
            )}
                {this.state.viewReadingImage && (
                    <div className="custom_modal">
                        <div className="modal_body">
                            <div className="row">
                                <div className="col-md-10">
                                    <h4 className="modal_title pagetitle">View Meter Reading Image</h4>
                                </div>
                                <div className="col-md-2">
                                    <button type="button" className="close text-right" style={{ fontSize: 20 }} onClick={(e) => this.setState({ viewReadingImage: false })}>&times;</button>
                                </div>
                                {(this.state.readingImageSource.includes("png") || this.state.readingImageSource.includes("jpg") || this.state.readingImageSource.includes("jpeg")) ? (
                                    <embed src={this.state.readingImageSource} title="photo" width="100%" height="auto" />
                                ) : (
                                    <embed src={this.state.readingImageSource} title="photo" width="100%" height="auto" style={{ height: '400px' }} />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default ReadingListTable
